
import { useI18n } from 'vue-i18n';
import AButton from "@/components/Base/AButton";
import Toolbar from "@/components/Navigation/Toolbar";
import useUser from "@/composables/useUser";
import {
  IonButton,
  IonButtons,
  IonContent,
  IonImg,
  IonPage,
  onIonViewWillEnter,
  IonCard,
} from "@ionic/vue";
import { computed, defineComponent } from "vue";
import UserDialogButton from "@/components/User/UserDialogButton.vue";
import { useStore } from "@/composables/useTypedStore";
import { useFaqs } from "@/composables/useFaqs";
import FaqItem from "@/components/Faq/faq-item.vue";

export default defineComponent({
  name: "FaqPage",
  components: {
    AButton,
    Toolbar,
    IonPage,
    IonButton,
    IonButtons,
    IonContent,
    IonImg,
    UserDialogButton,
    IonCard,
    FaqItem
  },
  setup() {
    const { t } = useI18n({ useScope: 'global' })
    const { user } = useUser();
    const store = useStore();

    const { faqs } = useFaqs();

    onIonViewWillEnter(() => {
      store.commit("app/showBottomNavigation");
    });

    return {
      user,
      faqs,
      t
    };
  },
});
